import PermissionsService from "@/services/permission.service";


const state = {
    Permissions: [],
};
const mutations = {
    set_permissions(state, payload) {
        state.AirportsList = payload;
    },
};
const actions = {
    async GetPermissions() {
        const hrPersonel = await PermissionsService.GetPermissionsService();
        return hrPersonel
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
